import React from "react";
import Header from "../../../../ui-components/LandingPage/ApiUi/Header";
// import TestimonialOne from "../../../ui-components/ApiUi/TestimonialOne";
import TestimonialTwo from "../../../../ui-components/LandingPage/ApiUi/TestimonialTwo";
import TestimonialThree from "../../../../ui-components/LandingPage/ApiUi/TestimonialThree";
import Cards from "../../../../ui-components/LandingPage/ApiUi/Cards";
import Context from "../../../../ui-components/LandingPage/ApiUi/Context";

const Api = () => {
  return (
    <>
      {/* <div className="min-[2000px]:px-36"> */}
      <Header />
      {/* <TestimonialOne /> */}
      <TestimonialTwo />
      <TestimonialThree />
      <Cards />
      <Context />
      {/* </div> */}
    </>
  );
};

export default Api;